import { Stack } from "@mantine/core"
import { IconPlus } from "@tabler/icons-react"
import type { Prisma } from "@tfg/db"
import { Button } from "@tfg/ui"

import { FiltersSection } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/FiltersSection.tsx"

interface FiltersFormProps {
  filters: Prisma.JsonObject
  setFiltersInForm: (filters: Prisma.JsonObject) => void
}
export const FiltersForm = ({
  filters,
  setFiltersInForm,
}: FiltersFormProps) => {
  return (
    <Stack>
      <FiltersSection filters={filters} setFilters={setFiltersInForm} />
      {Object.keys(filters).length === 0 && (
        <Button
          style={{ alignSelf: "flex-start" }}
          variant="tertiary"
          radius={50}
          size="xs"
          icon={<IconPlus />}
          onClick={() => {
            setFiltersInForm({ "": Object({ equals: "" }) })
          }}
        >
          Add filter
        </Button>
      )}
    </Stack>
  )
}
